module.exports = "https://tutorchat.chegg.com/static/media/chegg-logo.e2944824.svg";